import * as React from "react";
import { pieArcLabelClasses, PieChart } from "@mui/x-charts/PieChart";
import { DefaultChartsLegend } from "@mui/x-charts";

export default function PieChartGraph({
  data,
  total,
}: {
  data: any[];
  total: any;
}) {
  console.log("data :", data);
  const fallbackData = [
    {
      id: "noData",
      label: "No Data",
      value: 100, // a full pie slice
      color: "#d3d3d3", // light grey
    },
  ];
  const chartData = data?.every((data) => !data?.value) ? fallbackData : data;
  const formattedValue = (item: { value: number }) => {
    return chartData?.length === 1
      ? total
      : `${((item?.value / total) * 100).toFixed(2)}%`;
  };
  return (
    <div style={{ display: "flex" }}>
      <PieChart
        series={[
          {
            //   arcLabel: "formattedValue",
            //   arcLabelMinAngle: 50,
            innerRadius: 50,
            data: chartData,
            valueFormatter: formattedValue,
          },
        ]}
        slotProps={{ legend: { hidden: chartData?.length === 1 } }}
        width={300}
        height={160}
      />

      {chartData?.length === 1 ? (
        <div style={{ alignSelf: "center", marginLeft: -100 }}>
          <div>No Data Available</div>
        </div>
      ) : null}
    </div>
  );
}
